const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("WC map", "uipress-pro"),
  moduleName: "uip-woocommerce-analytics-map",
  description: __("Outputs order data from woocommerce as a interactive map", "uipress-lite"),
  group: "storeanalytics",
  icon: "map",
};
